import React from 'react'
import { Empty, Table } from 'antd'

export default function TaskReponsesUserTable({ data }) {

    const columns = [
        {
            title: 'Nombre de Tienda',
            dataIndex: ['store', 'name'],
        },
        {
            title: 'Código de Tienda',
            dataIndex: ['store', 'code'],
            render: t => t ? t : <em>Sin registro</em>
        },
        {
            title: 'Relevancia',
            dataIndex: ['store', 'relevance'],
            render: t => t ? t : <em>Sin especificar</em>
        },
        {
            title: 'Fecha Última Visita',
            dataIndex: 'last_visit_date',
            render: t => t ? t : <em>Sin visitas</em>
        },
        {
            title: '# Visitas en el mes',
            dataIndex: 'visits_count',
            render: t => `${t} ${t === 1 ? 'visita' : 'visitas'}`
        },
        {
            title: 'Hizo checklist',
            dataIndex: 'visits_with_checklist_count',
            render: t => `${t} ${t === 1 ? 'visita' : 'visitas'}`
        },
        {
            title: 'Checklist diligenciados',
            dataIndex: 'checklists_in_month',
            render: t => `${t} ${t === 1 ? 'checklist' : 'checklists'}`
        },
    ]

	return (
		<React.Fragment>
			<Table 
                dataSource={data} 
                columns={columns}
                rowKey={record => record.id}
                locale={{
                    emptyText: <Empty description="El usuario no tiene tareas registradas" />
                }}
            />
		</React.Fragment>
	)
}